import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { translate } from 'i18n/jhipster-language';
import { validateRequiredDescription } from 'shared/lib/validation/search-filters';
import { FIELD_CONSTRAINTS } from 'shared/lib/validation/field-constraints';
import PCol from 'shared/ui/pcol';
import { CreateHeader } from 'shared/ui/dialog-header';
import { approveRequest, clearMutationFlags } from 'shared/lib/reducers/card-replacement-request.reducer';
import { getCmsAccountApproverId } from 'shared/lib/cms-account-approver';
const mapState = ({ cardReplacementRequest }) => ({
    updating: cardReplacementRequest.updating,
    updateSuccess: cardReplacementRequest.updateSuccess,
});
const mapDispatch = {
    approve: approveRequest,
    clearFlags: clearMutationFlags,
};
const CardReplacementRequestApproveDialog = ({ visible, row, onHide, onApproved, updating, updateSuccess, approve, clearFlags, }) => {
    const toast = useRef(null);
    const [approverReason, setApproverReason] = useState('');
    const [approverReasonError, setApproverReasonError] = useState(null);
    useEffect(() => {
        if (!visible) {
            setApproverReason('');
            setApproverReasonError(null);
        }
    }, [visible, row?.id]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        toast.current?.show({
            severity: 'success',
            summary: translate('entity.action.successfullyUpdated'),
            life: 2500,
        });
        clearFlags();
        onApproved?.();
        onHide();
    }, [updateSuccess, clearFlags, onApproved, onHide]);
    const canSubmit = row?.status === 'REQUESTED' || row?.status === 'PENDING' || row?.status === 'SUBMITTED';
    const onApprove = async () => {
        if (row?.id == null || !canSubmit)
            return;
        const reason = approverReason.trim();
        const reasonError = validateRequiredDescription(approverReason);
        setApproverReasonError(reasonError);
        if (reasonError) {
            toast.current?.show({
                severity: 'warn',
                summary: translate('form.validation.required'),
                detail: reasonError,
                life: 3000,
            });
            return;
        }
        try {
            const approverId = await getCmsAccountApproverId();
            await approve(row.id, { approverId, approverReason: reason });
        }
        catch (e) {
            console.error(e);
            toast.current?.show({
                severity: 'error',
                summary: translate('general.submit'),
                detail: String(e instanceof Error ? e.message : e),
                life: 4000,
            });
        }
    };
    return (_jsxs(Dialog, { visible: visible, onHide: onHide, dismissableMask: true, style: { width: '520px' }, showHeader: false, children: [_jsx(Toast, { ref: toast }), _jsxs(PCol, { className: "p-mt-2", children: [_jsx(CreateHeader, { headername: translate('form.approve') }), _jsxs("label", { htmlFor: "replacement-approve-notes", className: "d-block mb-2 mt-3", children: [translate('form.approverReason'), " *"] }), _jsx(InputTextarea, { id: "replacement-approve-notes", className: "w-full", rows: 4, value: approverReason, disabled: !canSubmit, invalid: !!approverReasonError, maxLength: FIELD_CONSTRAINTS.DESCRIPTION_MAX, onChange: e => {
                            setApproverReason(e.target.value);
                            setApproverReasonError(null);
                        } }), approverReasonError ? _jsx("small", { className: "p-error", children: approverReasonError }) : null, _jsxs("div", { className: "p-d-flex p-jc-end mt-3", style: { gap: '0.5rem' }, children: [_jsx(Button, { type: "button", label: translate('entity.action.cancel'), className: "p-button-text", onClick: onHide }), _jsx(Button, { type: "button", className: "p-button-success", label: translate('form.action.approve'), loading: updating, disabled: updating || row?.id == null || !canSubmit, onClick: () => void onApprove() })] })] })] }));
};
export default connect(mapState, mapDispatch)(CardReplacementRequestApproveDialog);
